<template>
    <div class="p-md">
        <div class="app-block p-md" v-if="!registered">
            <h3 class="heading-line title is-4 has-text-weight-light"><span :class="'school-title-'+schoolSlug">{{ $t('candidate.registration.boardingschool.title') }}</span>
            </h3>
            <div class=" has-text-centered">

                <div class="heading-line title is-5 has-text-weight-light">
                    {{ $t('candidate.registration.eschool.admission') }}
                </div>

                <router-link class="button pedago-offers is-large has-text-weight-light"
                             :to="{ name: 'eshop-categories', params: { school: $route.params.school }}">
                    <span>{{ $t('candidate.registration.eschool.shop_link') }}</span>
                </router-link>

            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        data() {
            return {
                isLoading: '',
                errorMsg: ''
            }
        },
        props: {
            school: {type: Object},
            candidate: {type: Object}
        },
        computed: {
            ...mapGetters({
                status: 'candidate/getStatus'
            }),
            application () {
                return this.candidate.applications
            },
            registered () {
                return this.application.registration && this.application.registration.registered_candidate
            },
            schoolSlug() {
                return this.school ? this.school.slug:''
            }
        },
        methods: {

        }
    }
</script>
<style scoped>
    .pedago-offers {
        font-weight: 400 !important;
        color: #ffffff !important;
        background-color: #659f3d !important;
    }

    .candidate-admission {
        color: #659f3d
    }

    .candidate-admission h4 {
        font-size: 1.7em;
        color: #659f3d;
    }

    .admission-address {
        color: #000;
    }
</style>
